import React, { useEffect,useState } from "react";
import "./homepage-spinner.css";
import "./dashboard.css";
import SiteWrapper from "./SiteWrapper.js";
import { useDispatch, useSelector } from "react-redux";
import { getPermissionsByuser } from "../../redux/actions/permissions";
import PlusDashboard from "../../components/Cards/PlusDashboard";
import { useHistory } from "react-router-dom";
import HomepageSpinner from "../../../public/homepage/homepage-spinner.svg";
import GrcLogo from "../../../public/homepage/Grc.svg";
import KmLogo from "../../../public/homepage/Km.svg";
import SurveyLogo from "../../../public/homepage/Survey.svg";
import IvrLogo from "../../../public/homepage/Ivr.svg";
import ErpLogo from "../../../public/homepage/Erp.svg";
import CallLogo from "../../../public/homepage/Call.svg";
import VoipLogo from "../../../public/homepage/Voip.svg";
import QmLogo from "../../../public/homepage/Qm.svg";
import Roundgrc from "../../../public/homepage/RoundGrc.svg";
import Roundqm from "../../../public/homepage/RoundQm.svg";
import Roundvoip from "../../../public/homepage/Roundvoip.svg";
import Roundcall from "../../../public/homepage/RoundCall.svg";
import Rounderp from "../../../public/homepage/RoundErp.svg";
import Roundivr from "../../../public/homepage/RoundIVR.svg";
import Roundsurvey from "../../../public/homepage/RoundSurvey.svg";
import Roundkm from "../../../public/homepage/RoundIKm.svg";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import SmallNav from "../../components/layouts/SmallNav";
import { getAllEVALs, getEvalsByTenantId } from "../../redux/actions/evaluation";
import Managment from "../Managment";

import { styled } from "@mui/material/styles";
import BackDash from "../../assets/images/back-dash.svg"; 
/* import backgroundImage from "../../../public/homepage/background.jpg";
 */const HtmlTooltip = styled(({ bgColor, className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} arrow />
))(({ theme, bgColor, darkColor }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: bgColor,
    color: darkColor ? "#000000" : "#ffffff",
    maxWidth: 250,
    fontSize: "14px",
    border: "none",
    fontFamily: "Gilroy-Semibold",
    textAlign: "center",
    paddingTop: "11px",
    paddingBottom: "11px",
    paddingLeft: "30px",
    paddingRight: "30px",
    borderRadius: "10px",
  },
  ".MuiTooltip-arrow ": {
    color: bgColor,
  },
}));
const Dashboard = () => {
  const { isOpen } = useSelector((state) => state.design);
  const dispatch = useDispatch();
  const user_auth0 = JSON.parse(localStorage.getItem("user_auth0"));
  const { dataPermissionsByuser } = useSelector((state) => state.permissions);
  const history = useHistory();
  const [tooltipGrc, setTooltipGrc] = useState(false);
  const [tooltipKm, setTooltipKm] = useState(false);
  const [tooltipQm, setTooltipQm] = useState(false);
  const [tooltipVoip, setTooltipVoip] = useState(false);
  const [tooltipCall, setTooltipCall] = useState(false);
  const [tooltipErp, setTooltipErp] = useState(false);
  const [tooltipIvr, setTooltipIvr] = useState(false);
  const [tooltipSurvey, setTooltipSurvey] = useState(false);

  useEffect(() => {
    dispatch(getPermissionsByuser())
    fetchdata();
  }, [dispatch]);

  const fetchdata = () => {
    user_auth0["http://role.tn/roles"][0] === "SUPER-ADMIN"
    ? dispatch(getAllEVALs(0, 10))
    : dispatch(getEvalsByTenantId(0, 10));
  };

  return (
    <div className="d-flex flex-column">
      {
      user_auth0["http://role.tn/roles"][0] === "SUPER-ADMIN" ? (
        <Managment />
      ) : (
        <>
          <SmallNav />
          
          <div className="homepage-content">
            
            <img
              src={HomepageSpinner}
              alt="Homepage Spinner"
              className="homepage-spinner"
            />
            <div className="homepage-logos-block">
              <HtmlTooltip
                title={<>Pour le traitement des interactions de vos clients</>}
                open={tooltipGrc}
                placement="left"
                bgColor="#C17C00"
                darkColor={false}
              >
                
                <img src={Roundgrc} alt="Roundgrc" className="roundgrc" />
              </HtmlTooltip>
              <a href="https://roundesk.com/solution-gestion-relation-client-roundgrc/" target="_blank" >
              <img
                src={GrcLogo}
                alt="Grc Logo"
                className="roundesk-logos grc-logo"
                role="button"
                onMouseEnter={() => setTooltipGrc(true)}
                onMouseLeave={() => setTooltipGrc(false)}
              /></a>
              <HtmlTooltip
                title={<>Pour une centralisation des connaissances métiers</>}
                open={tooltipKm}
                placement="right"
                bgColor="#008C40"
                darkColor={false}
              >
                <img src={Roundkm} alt="RoundKm" className="roundkm" />
              </HtmlTooltip>
              <img
                src={KmLogo}
                alt="Km Logo"
                className="roundesk-logos km-logo"
                role="button"
                onMouseEnter={() => setTooltipKm(true)}
                onMouseLeave={() => setTooltipKm(false)}
              />
              <HtmlTooltip
            title={<> Pour une mesure de la satisfaction client</>}
            open={tooltipSurvey}
            placement="right"
            bgColor="#FBC908"
            darkColor={true}
          >
            <img src={Roundsurvey} alt="RoundSurvey" className="roundsurvey" />
          </HtmlTooltip>
          <img
            src={SurveyLogo}
            alt="Survey Logo"
            className="roundesk-logos survey-logo"
            role="button"
            onMouseEnter={() => setTooltipSurvey(true)}
            onMouseLeave={() => setTooltipSurvey(false)}
          />
          <HtmlTooltip
            title={<>Pour Assistant virtuel métier qui qualifie vos demandes</>}
            open={tooltipIvr}
            placement="right"
            bgColor="#5347B2"
            darkColor={false}
          >
            <img src={Roundivr} alt="RoundIVR" className="roundivr" />
          </HtmlTooltip>
          <img
            src={IvrLogo}
            alt="IVR Logo"
            className="roundesk-logos ivr-logo"
            role="button"
            onMouseEnter={() => setTooltipIvr(true)}
            onMouseLeave={() => setTooltipIvr(false)}
          />
          <HtmlTooltip
            title={<>Pour une gestion unifiée de votre organisation</>}
            open={tooltipErp}
            placement="right"
            bgColor="#143B7A"
            darkColor={false}
          >
            <img src={Rounderp} alt="RoundErp" className="rounderp" />
          </HtmlTooltip>
          <a href="https://roundesk.com/progiciel-de-gestion-rounderp/" target="_blank">
          <img
            src={ErpLogo}
            alt="Erp Logo"
            className="roundesk-logos erp-logo"
            role="button"
            onMouseEnter={() => setTooltipErp(true)}
            onMouseLeave={() => setTooltipErp(false)}
          /></a>
          <HtmlTooltip
            title={<>Pour personnaliser votre accueil téléphonique</>}
            open={tooltipCall}
            placement="left"
            bgColor="#1D8211"
            darkColor={false}
          >
            <img src={Roundcall} alt="RoundCall" className="roundcall" />
          </HtmlTooltip>
          <a href="https://roundesk.com/outil-telephonie-roundcall/" target="_blank">
          <img
            src={CallLogo}
            alt="Call Logo"
            className="roundesk-logos call-logo"
            role="button"
            onMouseEnter={() => setTooltipCall(true)}
            onMouseLeave={() => setTooltipCall(false)}
          /></a>
          <HtmlTooltip
            title={<>Pour virtualiser votre téléphonie d’entrerpise</>}
            open={tooltipVoip}
            placement="left"
            bgColor="#181B36"
            darkColor={false}
          >
                      
            <img src={Roundvoip} alt="RoundVoip" className="roundvoip" />
          </HtmlTooltip>
          <a href="https://roundesk.com/solution-telephonie-voip-roundvoip/" target="_blank" >

          <img
            src={VoipLogo}
            alt="Voip Logo"
            className="roundesk-logos voip-logo"
            role="button"
            onMouseEnter={() => setTooltipVoip(true)}
            onMouseLeave={() => setTooltipVoip(false)}
          /></a>
          <HtmlTooltip
            title={<>Pour des évaluations de qualité</>}
            open={tooltipQm}
            placement="left"
            bgColor="#4300AB"
            darkColor={false}
          >
            <img src={Roundqm} alt="RoundQm" className="roundqm" />
          </HtmlTooltip>
          <a href="https://roundesk.com/logiciel-quality-monitoring-roundqm/" target="_blank" >

          <img
            src={QmLogo}
            alt="Qm Logo"
            className="roundesk-logos qm-logo"
            role="button"
            onMouseEnter={() => setTooltipQm(true)}
            onMouseLeave={() => setTooltipQm(false)}
          /></a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;